import { Grid, Paper, Pagination, Stack, Typography } from "@mui/material"
import { useState, useEffect } from "react"
import FilterSort from "../ui/FilterSort"
import { useSnackbar } from "notistack"
import LoadingContent from "../common/LoadingContent"

const ListData = ({
  getFilters,
  getSort,
  getAllData,
  initialFilters,
  HeaderRight,
  HeaderCentre,
  HeaderFull,
  refresh,
  Card,
  type = "BARS",
  getDataBody,
  openEditCard,
  openDeleteCard,
  emptyText,
  dataKey,
  noView,
  noFilterSort,
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState()
  const [sorts, setSorts] = useState(null)
  const [pages, setPages] = useState(10)
  const [curPage, setCurPage] = useState(1)
  // eslint-disable-next-line no-unused-vars
  const [limit, setLimit] = useState(6)
  const [totalCount, setTotalCount] = useState(0)

  const fetchFilters = async () => {
    await getFilters()
      .then(({ data }) => setFilters(data))
      .catch((err) => console.log(err))
  }

  const fetchSort = async () => {
    await getSort()
      .then(({ data }) => setSorts(data))
      .catch((err) => console.log(err))
  }

  const handlePageChange = (event, value) => {
    setCurPage(value)
  }

  const fetchData = async (options = {}) => {
    setLoading(true)
    await getAllData({ ...options, ...getDataBody, limit, page: curPage })
      .then((res) => {
        setData(dataKey ? res.data[dataKey] : res.data.rows)
        setPages(res.data?.totalPages || Math.ceil(res.data.count / limit))
        setTotalCount(res.data.count)
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    {!noFilterSort && fetchFilters()}
    {!noFilterSort && fetchSort()}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const reset = () => {
    fetchData(initialFilters)
  }

  useEffect(() => {
    fetchData(initialFilters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curPage, refresh])

  return (
    <>
    {HeaderFull && <HeaderFull />}
      <Stack
        direction={"row-reverse"}
        justifyContent="space-between"
        marginBottom={2}
      >
        {!noFilterSort && <FilterSort data={{ filters, sorts }} fetch={fetchData} />}
        {HeaderCentre && <HeaderCentre />}
        {HeaderRight && <HeaderRight />}
      </Stack>
      <LoadingContent loading={loading}>
        {data?.length ? (
          type === "BARS" ? (
            <Stack sx={{ minHeight: "46vh" }}>
              {data.map((item) => (
                <Card key={item.id} data={item} reset={reset} noView={noView}/>
              ))}
            </Stack>
          ) : (
            <Grid container spacing={3} marginTop={1}>
              {data.map((item) => (
                <Grid key={item.id} item xs={12} sm={4}>
                  <Card
                    key={item.id}
                    data={item}
                    edit={() => openEditCard(item)}
                    remove={() => openDeleteCard(item)}
                    reset={reset}
                    noView={noView}
                  />
                </Grid>
              ))}
            </Grid>
          )
        ) : (
          <Typography sx={{ textAlign: "center", py: 5 }}>
            {emptyText || "No records found"}
          </Typography>
        )}
      </LoadingContent>
      {!loading && !!totalCount && (
        <Stack
          direction="row"
          component={Paper}
          alignItems="center"
          justifyContent="space-between"
          sx={{
            position: "sticky",
            bottom: {
              xs: "3.8rem",
              sm: 0,
            },
            mt: 1,
            p: {
              xs: 1,
              sm: 2,
            },
            borderTop: 1,
            borderColor: "rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: 12,
                sm: 16,
              },
            }}
          >
            Showing ({(curPage - 1) * limit + 1} -{" "}
            {Math.min(curPage * limit, totalCount)}) of {totalCount} results
          </Typography>
          <Pagination
            count={pages}
            page={curPage}
            onChange={handlePageChange}
          />
        </Stack>
      )}
    </>
  )
}

export default ListData
